export default __webpack_public_path__ + "static/media/maryland.628606a2.jpg";